import { cn } from '@/lib/utils';

type DetailsFieldProps = {
  label: string;
  value?: string | number | null;
  className?: string;
};

export const DetailsField = ({ label, value = '', className }: DetailsFieldProps) => {
  return (
    <div className={cn('grid grid-cols-2 gap-2', className)}>
      <p className="min-w-[20%] grow-0 text-base text-text-secondary">{label}:</p>
      <p className="w-4/5 self-end whitespace-nowrap break-words text-base">
        {value ? value : '-'}
      </p>
    </div>
  );
};
